/**
 * Password policy - CIBRAXIS Iteration 35.
 *
 * Mirror of /app/backend/services/password_policy.py so the UI can render the
 * strength meter in real time BEFORE the user submits. Backend is still the
 * source of truth (both validate on submit).
 */
export const MIN_LENGTH = 14;
export const HISTORY_SIZE = 5;

export const RULES = [
  { id: "length",  label: `Mínimo ${MIN_LENGTH} caracteres`,                            test: (p) => (p || "").length >= MIN_LENGTH },
  { id: "upper",   label: "Al menos una MAYÚSCULA (A-Z)",                                test: (p) => /[A-Z]/.test(p || "") },
  { id: "lower",   label: "Al menos una minúscula (a-z)",                                test: (p) => /[a-z]/.test(p || "") },
  { id: "digit",   label: "Al menos un dígito (0-9)",                                    test: (p) => /\d/.test(p || "") },
  { id: "special", label: "Al menos un símbolo (. , * ! @ # $ % & etc.)",               test: (p) => /[^A-Za-z0-9\s]/.test(p || "") },
];

export function ruleStatus(pwd) {
  return RULES.reduce((acc, r) => ({ ...acc, [r.id]: r.test(pwd) }), {});
}

export function validate(pwd) {
  const errors = [];
  for (const r of RULES) if (!r.test(pwd)) errors.push(r.label);
  return { ok: errors.length === 0, errors };
}

/** 0-4 strength score, matches backend algorithm. */
export function strength(pwd) {
  const { ok } = validate(pwd);
  if (!ok) {
    const base = Object.values(ruleStatus(pwd)).filter(Boolean).length;
    return base <= 2 ? 0 : 1;
  }
  if ((pwd || "").length >= 22) return 4;
  if ((pwd || "").length >= 18) return 3;
  return 2;
}

export const STRENGTH_META = [
  { label: "Muy débil",  color: "#FF2E93" },
  { label: "Débil",       color: "#FF6B00" },
  { label: "Aceptable",   color: "#F1D302" },
  { label: "Fuerte",      color: "#00E5FF" },
  { label: "Excelente",   color: "#22c55e" },
];
